import React, { useState, useEffect } from 'react'
import { Link, navigate } from 'gatsby'
import { auth0Roles } from '../../../config'
import cookies from 'react-cookies'
const Navigation = ({
  employerFacing,
  userRole,
  location,
  showDropdownOnMobile,
  // openSignupModalFromChild,
  toggleBlur,
}) => {
  let user = cookies.load('user')
  const navigationItems = {
    general: [
      {
        label: 'SEARCH JOBS',
        href: '/job-search/',
        active: false,
      },
      {
        label: 'CAREER ADVICE',
        href: '/medical-sales-careers/',
        active: false,
      },
      {
        label: 'MEDICAL SALES SALARIES',
        href: '/salary/',
        active: false,
      },
      {
        label: `${!userRole ? 'POST JOBS' : 'DASHBOARD '}`,
        href: `${
          !userRole
            ? '/hiring-with-medReps/'
            : userRole === auth0Roles.NamedUser.id ||
              userRole === auth0Roles.Employer.id
            ? '/employer-dashboard/'
            : '/member-dashboard/'
        }`,
        active: false,
      },
    ],
    employerPage: [
      {
        label: 'HIRING WITH MEDREPS',
        href: '/employer/signup/',
      },
    ],
  }
  const [sidebarOpenOrClose, setSidebarOpenOrClose] = useState(false)
  const [navItems, setNavItems] = useState(navigationItems.general)
  let slug
  if (typeof window !== 'undefined') {
    slug = new URL(typeof window !== 'undefined' && window.location).pathname
      .match(/[^\/]+/g)
      ?.join('/')
  }

  useEffect(() => {
    if (
      (slug && slug.indexOf('hiring-with-medReps') !== -1) ||
      (slug && slug.indexOf('employer/signup') !== -1)
    ) {
      setNavItems(navigationItems.employerPage)
    } else {
      setNavItems(navigationItems.general)
    }

    showDropdownOnMobile.current = toggleMobileMenu
  }, [slug, sidebarOpenOrClose])

  function toggleMobileMenu() {
    toggleBlur()
    setSidebarOpenOrClose(!sidebarOpenOrClose)
  }

  const navigateJoinNow = () => {
    navigate('/join-now')
  }

  const NavigationItemsMarkup = () => {
    const items = navItems?.map((link, index) => {
      if (link.isExternal) {
        return (
          <>
            <li className="mb-0 flex mx:0 sm:mx-6" key={index}>
              <a
                target={link.target}
                className={`text-black md:text-white hover:text-poppy pt-2 pb-2 border-b-2 border-transparent hover:border-white text-base font-sans uppercase`}
                href={link?.href}
              >
                {link.label}
              </a>
            </li>
          </>
        )
      } else {
        return (
          <li className="mb-0 flex mx:0 sm:mx-6" key={index}>
            <Link
              className={`text-black md:text-white hover:text-poppy pt-2 pb-2 border-b-2 hover:border-white text-lg font-sans uppercase ${
                location?.pathname !== '/' &&
                location?.pathname?.indexOf(link?.href) !== -1
                  ? 'text-poppy border-b-2 border-white'
                  : 'border-transparent'
              } `}
              to={link?.href}
            >
              {link.label}
            </Link>
          </li>
        )
      }
    })
    return items
  }
  return (
    <>
      <div
        className={`${
          sidebarOpenOrClose ? 'shown' : 'hidden'
        } sidebar visible md:invisible text-center pt-8 pb-4`}
      >
        <img
          className="absolute cursor-pointer"
          onClick={() => toggleMobileMenu()}
          src="/icons/icon-close-modal.svg"
        />
        <NavigationItemsMarkup />
        {employerFacing && !user ? (
          <Link to="/employer/signup">
            <button className="text-white py-4 px-10 bg-voyage cursor-pointer font-sans font-bold rounded">
              Register
            </button>
          </Link>
        ) : (
          !user && (
            <button
              onClick={() => navigateJoinNow()}
              className="text-white py-4 px-10 bg-button cursor-pointer font-sans rounded"
            >
              Join Now
            </button>
          )
        )}
      </div>
      <div
        className={`sub-nav ${
          employerFacing ? 'bg-voyage' : 'bg-charcoal'
        } hidden md:block`}
      >
        <div className="container mx-auto">
          <div className={`${employerFacing ? 'w-4/5' : ''} mx-auto`}>
            <ul
              className={`${
                employerFacing
                  ? userRole
                    ? 'justify-center'
                    : ''
                  : 'justify-center'
              } flex mb-0 py-0 ml-0`}
            >
              <NavigationItemsMarkup />
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
export default Navigation
